export const HOW_IT_WORKS_SECTIONS = [
    {
        id: 'basics',
        emoji: '🎬',
        title: 'The Basics',
        anchor: 'basics',
        body: [
            'Watch a movie or TV season, then come back to Aluvo and take the 8-question challenge.',
            'Answer at least 5 out of 8 correctly to pass and earn a verified coin.',
            'Your coin is permanently attached to your profile and trophy case.',
            'You can share individual coins or your full profile with anyone.',
        ],
    },
    {
        id: 'tiers',
        emoji: '🪙',
        title: 'Coin Tiers',
        anchor: 'tiers',
        body: [
            'Every challenge result maps to a tier based on how many of the 8 questions you answered correctly:',
        ],
        tiers: [
            { label: 'Bronze',    emoji: '🥉', score: '5 / 8',          description: 'Verified — you passed' },
            { label: 'Silver',    emoji: '🥈', score: '6–7 / 8',        description: 'Strong knowledge' },
            { label: 'Gold',      emoji: '🥇', score: '8 / 8',          description: 'Perfect on first attempt (or upgrade path)' },
            { label: 'Legendary', emoji: '💎', score: '8 / 8 (see below)', description: 'Mastery — earned through the upgrade path' },
        ],
        footer: 'Scoring below 5/8 does not earn a coin. You can retry after the cooldown.',
    },
    {
        id: 'upgrading',
        emoji: '✨',
        title: 'Upgrading Coins',
        anchor: 'upgrading',
        body: [
            'If you hold a Bronze or Silver coin you can take another challenge to upgrade it.',
            'There is a 1-hour cooldown between each attempt.',
            'A higher score on a retry replaces your current coin with the better tier.',
            'You never lose your coin by retrying — it only goes up, never down.',
            'Bronze → Silver requires 6+ correct. Bronze or Silver → Gold requires a perfect 8.',
        ],
    },
    {
        id: 'legendary',
        emoji: '💎',
        title: 'Unlocking Legendary',
        anchor: 'legendary',
        body: [
            'Legendary is not earned in a single challenge — it requires proving mastery twice.',
            '',
            'Step 1 — Earn Gold by scoring 8/8 on any attempt.',
            'Step 2 — Wait 24 hours. A Legendary attempt then unlocks on your Gold coin.',
            'Step 3 — Take the Legendary Challenge and score a perfect 8/8 again to unlock Legendary.',
            '',
            'If you score below 8/8 during a Legendary attempt, your Gold coin is kept safe — you just need to wait another 24 hours before trying again.',
            'Once Legendary is reached, no further attempts are available for that title.',
        ],
        highlight: 'Earn Gold → wait 24 hours → score perfect again → Legendary.',
    },
    {
        id: 'series-mastery',
        emoji: '⭐',
        title: 'Series Mastery',
        anchor: 'series-mastery',
        body: [
            'Verify enough seasons of a TV series (Bronze or higher each) to earn a special Series Mastery coin.',
            'A verified season means you passed the challenge for that season at any tier.',
            '',
            'How many seasons are required depends on the total season count:',
        ],
        masteryTable: [
            { range: '1–3 seasons', required: 'All seasons' },
            { range: '4–7 seasons', required: '80% rounded up  (e.g. 5 of 6)' },
            { range: '8+ seasons',  required: '6 seasons' },
        ],
        footer: 'Series Mastery coins are unique, visually distinct coins that also count toward Collections.',
    },
    {
        id: 'collections',
        emoji: '🏆',
        title: 'Collections',
        anchor: 'collections',
        body: [
            'Collections group related titles — a director\'s filmography, a franchise, a genre set.',
            'Verify every required title in a collection (Bronze or higher counts) to unlock a Legendary reward coin.',
            'Some collections require a Series Mastery coin rather than individual season coins.',
            'Collection coins appear in your trophy case under the Collections tab.',
            'Completing a collection is the primary way to earn Legendary coins without the Gold upgrade path.',
        ],
    },
    {
        id: 'aluvo-picks',
        emoji: '🍿',
        title: 'Aluvo Picks',
        anchor: 'aluvo-picks',
        body: [
            'Aluvo Picks are curated lists put together by the Aluvo team — starter packs, essentials, weekend picks, director spotlights, and genre or era guides.',
            'Find them under Aluvo Picks in Discover on the web, or the Aluvo Picks tab in Search on mobile. They are also suggested on a title\'s page when it appears in a list.',
            '',
            'Open a list to see every title in it, along with a short note on why it was included.',
            'Once you are signed in, each list also tracks your progress — how many of its titles you have already verified.',
            'Verify any title straight from the list to jump into its challenge, or add everything you have not watched to your watchlist in one go.',
            '',
            'You can browse Picks without an account, but progress only appears once you sign in.',
        ],
        footer: 'Picks do not award a coin of their own — they are a guided route to the coins you earn title by title. For lists that do award a reward coin, see Collections.',
    },
    {
        id: 'reactions',
        emoji: '❤️',
        title: 'Reactions & Sharing',
        anchor: 'reactions',
        body: [
            'After passing a challenge you can rate the title (Loved it / Liked it / It was okay).',
            'Ratings are only available once you have a verified coin — no coin, no reaction.',
            'Share any individual coin via its detail page, or share your full trophy case from your profile.',
            'Public share links work without an Aluvo account, so anyone can see your verified coins.',
        ],
    },
];

export const HELP_ANCHORS = {
    TIERS:          'tiers',
    LEGENDARY:      'legendary',
    UPGRADING:      'upgrading',
    COLLECTIONS:    'collections',
    SERIES_MASTERY: 'series-mastery',
};